"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCruiseDetailsEvent = exports.handleCruiseSearchEvent = void 0;
var lodash_1 = require("lodash");
var moment = require("moment");
var durationToDescription = {
    0: 'beliebig',
    1: '1-5 Tage',
    6: '6-9 Tage',
    10: '10-13 Tage',
    14: '14-21 Tage',
    22: 'ab 22 Tage',
};
var handleCruiseSearchEvent = function (mutation, state) {
    var params = (0, lodash_1.get)(state, 'searching.search.params', {
        adults: 0,
        juveniles: 0,
        children: 0,
    });
    var numSelectedFilters = (0, lodash_1.sumBy)((0, lodash_1.values)(params), function (param) {
        return (0, lodash_1.isNil)(param) ? 0 : 1;
    });
    var paxConfig = {
        adults: params.adults,
        juveniles: params.juveniles,
        children: params.children,
    };
    var configuredPaxe = (0, lodash_1.sumBy)((0, lodash_1.values)(paxConfig), function (param) {
        return (0, lodash_1.isNil)(param) ? 0 : 1;
    });
    numSelectedFilters -= configuredPaxe - 1;
    if (params.timeFrom && params.timeTo) {
        numSelectedFilters--;
    }
    var start = params.timeFrom;
    var end = params.timeTo;
    var regionID = params.regionID;
    var availableRegions = (0, lodash_1.get)(state, 'searching.search.availableRegions', []);
    var regionName = regionID
        ? (0, lodash_1.defaultTo)((0, lodash_1.find)(availableRegions, ['id', regionID]), { name: regionID })
            .name
        : undefined;
    var adults = params.adults;
    var juveniles = params.juveniles;
    var children = params.children;
    var departureAirport = params.departureAirport;
    var shipID = params.ship;
    var extraFilter = params.extraFilter;
    var travelDuration = params.travelDuration;
    var searchResults = (0, lodash_1.get)(state, 'searching.search.searchResults', []);
    var numberOfResults = (0, lodash_1.get)(state, 'searching.search.numFilteredCruises', (0, lodash_1.sumBy)(searchResults, function (result) {
        return (0, lodash_1.get)(result, 'cruises.length', 0);
    }));
    var events = [
        {
            event: 'Cruise Search',
            searchTravelDate: start || end ? "".concat(start, " bis ").concat(end) : 'not selected',
            searchRegion: (0, lodash_1.defaultTo)(regionName, 'not selected'),
            searchPassenger: "A".concat(adults, "_J").concat(juveniles, "_C").concat(children),
            searchDepartureAirport: (0, lodash_1.defaultTo)(departureAirport, 'not selected'),
            searchShip: (0, lodash_1.defaultTo)(shipID, 'not selected'),
            searchExtraFilter: (0, lodash_1.defaultTo)(extraFilter, 'not selected'),
            searchTravelDuration: (0, lodash_1.isNil)(travelDuration)
                ? 'not selected'
                : (0, lodash_1.defaultTo)(durationToDescription[travelDuration], travelDuration.toString()),
            searchNumberOfResults: numberOfResults.toString(),
            searchSelectedItems: numSelectedFilters.toString(),
        },
    ];
    return events;
};
exports.handleCruiseSearchEvent = handleCruiseSearchEvent;
var handleCruiseDetailsEvent = function (mutation, state) {
    var agencyId = (0, lodash_1.get)(state, 'booking.affiliate.agencyId', '');
    var events = [
        {
            event: 'EECproductDetailView',
            ecommerce: {
                dimension67: agencyId,
                detail: {
                    actionField: { list: 'BEA' },
                    products: [
                        {
                            name: (0, lodash_1.get)(state, 'searching.cruises.current.itinerary[0].name'),
                            id: (0, lodash_1.get)(state, 'searching.cruises.current.id'),
                            price: (0, lodash_1.get)(state, 'searching.cruises.selectedCabinCategory.price'),
                            brand: (0, lodash_1.get)(state, 'searching.cruises.current.ships[0].name'),
                            category: (0, lodash_1.get)(state, 'searching.cruises.priceModel'),
                            variant: (0, lodash_1.get)(state, 'searching.cruises.selectedCabinCategory.mainName'),
                            dimension31: (0, lodash_1.get)(state, 'searching.cruises.current.id'),
                            dimension32: 'cruise',
                            dimension34: getDeparturePortName(state),
                            dimension35: getArrivalPortName(state),
                            dimension36: (0, lodash_1.get)(state, 'searching.cruises.current.itinerary[0].name'),
                            dimension37: (0, lodash_1.get)(state, 'searching.cruises.current.region[0].name'),
                            dimension38: getPersons(state),
                            dimension39: (0, lodash_1.get)(state, 'searching.cruises.current.duration'),
                            dimension40: (0, lodash_1.get)(state, 'searching.cruises.current.startDate'),
                            dimension41: (0, lodash_1.get)(state, 'searching.cruises.current.endDate'),
                            dimension45: getDaysToCruise(state),
                        },
                    ],
                },
            },
        },
    ];
    return events;
};
exports.handleCruiseDetailsEvent = handleCruiseDetailsEvent;
function getDeparturePortName(state) {
    var firstPort = 'searching.cruises.current.journeys[0].segments[0].portID';
    var firstPortId = (0, lodash_1.get)(state, firstPort);
    var portList = (0, lodash_1.get)(state, 'searching.cruises.current.ports');
    var departurePort = (0, lodash_1.find)(portList, { id: firstPortId });
    return departurePort ? departurePort.name : undefined;
}
function getArrivalPortName(state) {
    var segments = (0, lodash_1.get)(state, 'searching.cruises.current.journeys[0].segments');
    var index = segments.length - 1;
    var lastPort = "searching.cruises.current.journeys[0].segments[".concat(index, "].portID");
    var lastPortId = (0, lodash_1.get)(state, lastPort);
    var portList = (0, lodash_1.get)(state, 'searching.cruises.current.ports');
    var arrivalPort = (0, lodash_1.find)(portList, { id: lastPortId });
    return arrivalPort ? arrivalPort.name : undefined;
}
function getPersons(state) {
    var _a = (0, lodash_1.get)(state, 'searching.persons'), adults = _a.adults, children = _a.children, juveniles = _a.juveniles;
    return "A".concat(adults, "_J").concat(juveniles, "_C").concat(children);
}
function getDaysToCruise(state) {
    var startDateString = (0, lodash_1.get)(state, 'searching.cruises.current.startDate');
    var isoString = startDateString
        .split('.')
        .reverse()
        .join('-');
    var start = moment(isoString);
    var now = moment();
    return Math.floor(moment.duration(start.diff(now)).asDays()).toString();
}
//# sourceMappingURL=cruise_search_event.js.map